import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import Modal from '@/components/Modal.vue';

import {
  computed,
  useSlots,
  onBeforeUnmount,
  onMounted,
  ref,
} from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ExitPopup',
  props: {
  once: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  oncePerVisit: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  small: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  enabled: {
    type: Boolean,
    required: false,
    default: () => true,
  },
  loading: {
    type: Boolean,
    required: false,
    default: () => false,
  },
  headline: {
    type: String,
    required: false,
    default: () => null,
  },
},
  emits: ['modalclose'],
  setup(__props, { emit: __emit }) {

const props = __props;

const emit = __emit;

const slots = useSlots();

const modal = ref<InstanceType<typeof Modal>>();

const content = slots.default ? slots.default() : null;
const hasContent = computed(() => (
  content && content[0] ? `${content[0].children}`.trim().length > 0 : false
));

const getChildrenHtml = (slotChildren: any) => {
  if (Array.isArray(slotChildren?.children)) {
    return slotChildren.children.map((c: any) => getChildrenHtml(c)).filter((c: any) => c !== null);
  }

  if (typeof slotChildren?.children === 'string') {
    return slotChildren?.children.trim();
  }

  if (slotChildren.el) {
    return slotChildren.el.innerHTML.trim();
  }

  if (slotChildren.props) {
    return JSON.stringify(slotChildren.props).trim();
  }

  return null;
};

const contentHtml = (content || [])
  .map((c: any) => getChildrenHtml(c))
  .filter((c) => c !== null)
  .join();

const contentHash = computed(() => (
  hasContent.value ? Buffer.from(contentHtml, 'utf8').toString('base64') : null
));

let storedTimestamp = JSON.parse(localStorage.getItem(`ep-${contentHash.value}`) || 'null');
if (storedTimestamp) {
  const lastDateShown = new Date(parseInt(storedTimestamp, 10));
  const diffInHours = Math.abs(Date.now() - lastDateShown.getTime()) / (60 * 60 * 1000);

  if (diffInHours >= 2) {
    storedTimestamp = null;
  }
}
const alreadyShown = ref(storedTimestamp !== null);

const showPopup = () => {
  if (props.enabled && modal.value && !alreadyShown.value) {
    modal.value.open();
    if (props.once || props.oncePerVisit) {
      alreadyShown.value = true;
    }
    if (props.oncePerVisit) {
      localStorage.setItem(`ep-${contentHash.value}`, `${new Date().getTime()}`);
    }
  }
};

const emitModalClose = () => {
  emit('modalclose', true);
};

onMounted(() => {
  window.document.documentElement.addEventListener('mouseleave', showPopup);
});

onBeforeUnmount(() => {
  window.document.documentElement.removeEventListener('mouseleave', showPopup);
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modal",
    ref: modal,
    small: __props.small,
    headline: __props.headline,
    loading: __props.loading,
    onClose: emitModalClose
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["small", "headline", "loading"]))
}
}

})